import Form from 'components/Profile/MedicalHistory/Form';
import ViewGate from 'components/Profile/View/Gate';

const MedicalHistory = () => {
  return (
    <ViewGate stepId="medical">
      {(editProps) => <Form {...editProps} />}
    </ViewGate>
  )
}

export default MedicalHistory;
